// extracted by mini-css-extract-plugin
export var dropdownButton = "_2h-0";
export var fullWidthDropdownButton = "_2h-1";
export var icon = "_2h-3";
export var iconPlaceholder = "_2h-2";
export var shortcutContainer = "_2h-4";